export default __webpack_public_path__ + "static/store_tiny-6f528f142a6eb491bc65a048d4be1920.jpg";